
import UiIcon from "@/components/UI/UiIcon.vue";

export default {
  name: "SearchResultItem",
  components: {
    UiIcon,
  },
  props: {
    as: {
      type: String,
      default: "li",
    },
    product: {
      type: Object,
      required: true,
    },
    search: {
      type: String,
      required: true,
    },
  },
  computed: {
    titleWithHighlight() {
      const safeHighlight = this.search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const re = new RegExp(safeHighlight, "gi");
      return this.product.title.replace(re, "<span class='tw-font-medium'>$&</span>");
    },
    productLink() {
      return this.localePath({
        path: `/product/${this.product?.slug}`,
        query: {
          configuration_id: this.product?.configuration_id,
          size: "default",
        },
      });
    },
  },
};
